<script setup lang="ts">
import { computed } from 'vue';
const props = defineProps<{
  to?: string;
  icon: string;
  label: string;
  badge?: number;
  expandable?: boolean;
  active?: boolean;
  isExpanded?: boolean;
  subItems?: Array<{ to: string; label: string; tag?: string; active?: boolean }>;
}>();

const emit = defineEmits<{
  toggle: [];
}>();

const toggle = () => {
  if (props.expandable) {
    emit('toggle');
  }
};

const itemClasses = computed(() => ({
  'nav-item': true,
  'expandable': props.expandable,
  'expanded': props.isExpanded,
  'active': props.active,
}));
</script>

<template>
  <div :class="itemClasses">
    <!-- Simple link item -->
    <RouterLink v-if="to && !expandable" :to="to">
      <bb-icon :name="icon" class="nav-icon" decorative></bb-icon>
      <span class="nav-text">{{ label }}</span>
      <span v-if="badge" class="nav-badge">{{ badge }}</span>
    </RouterLink>

    <!-- Expandable item. With a `to` it navigates AND toggles the submenu;
         without one it is a pure group header that only toggles. -->
    <template v-else-if="expandable">
      <RouterLink v-if="to" :to="to" class="nav-link" @click="toggle">
        <bb-icon :name="icon" class="nav-icon" decorative></bb-icon>
        <span class="nav-text">{{ label }}</span>
        <bb-icon name="chevron_right" class="nav-chevron" decorative></bb-icon>
      </RouterLink>
      <button v-else type="button" class="nav-link" @click="toggle">
        <bb-icon :name="icon" class="nav-icon" decorative></bb-icon>
        <span class="nav-text">{{ label }}</span>
        <bb-icon name="chevron_right" class="nav-chevron" decorative></bb-icon>
      </button>

      <div class="sub-menu" v-if="subItems">
        <RouterLink
          v-for="item in subItems"
          :key="item.to"
          :to="item.to"
          :class="{ active: item.active }"
        >
          {{ item.label }}<span v-if="item.tag" class="bb-tag -size-xs -info sub-menu-tag">{{ item.tag }}</span>
        </RouterLink>
      </div>
    </template>

    <!-- Button with chevron (like "Have an Idea?") -->
    <button v-else-if="!to" type="button" class="nav-link">
      <bb-icon :name="icon" class="nav-icon" decorative></bb-icon>
      <span class="nav-text">{{ label }}</span>
      <bb-icon name="chevron_right" class="nav-chevron" decorative></bb-icon>
    </button>
  </div>
</template>
